/* eslint-disable import/no-default-export */
import { State } from 'app/gamma/src/modules/types';
import React from 'react';
import { connect } from 'react-redux';
import styles from './header.less';

interface Props {
  brandingLogo: string | undefined;
}

class HeaderBrandingLogo extends React.Component<Props> {
  render() {
    const { brandingLogo } = this.props;
    if (!brandingLogo) {
      return null;
    }

    return (
      <img
        className={styles.brandingLogo}
        src={brandingLogo}
        alt=""
        role="presentation"
      />
    );
  }
}

function mapStateToProps(state: State) {
  return {
    brandingLogo: state.ui.header.brandingLogo,
  };
}

export default connect(mapStateToProps)(HeaderBrandingLogo);
